module.exports = __webpack_public_path__ + "img/12-small.3a5e3ce0.png";